import GET_BRANDS from '@/graphql/Brands.gql'
import { ref } from '@vue/composition-api'
import { useQuery, useResult } from '@vue/apollo-composable'

export function useBrands() {
  const supplierId = ref('')
  const take = ref(500)
  const { result, loading, error, refetch } = useQuery(
    GET_BRANDS,
    () => ({
      supplierId,
      take,
    }),
    { fetchPolicy: 'cache-first' }
  )
  const brands = useResult(result, [], data => data.brands)
  return { brands, loading, error, supplierId, refetch }
}
